import React, { PropsWithChildren } from 'react';
import { Controller } from 'react-hook-form';
import styles from './QuashedForm.module.scss';
import { FieldTypeMap, TextInput } from 'components/form-fields-v2';
import { getInfoWarningText } from 'components/form-engine/utils';
import { getValidator } from 'components/form-engine/validation';
import { IFormQuestion } from 'types';

interface IProps {
  control: any;
  error?: boolean;
  className?: string;
  inputClassName?: string;
  formValues: any;
  question: IFormQuestion;
  onChange?(...args): void;
}

const QuashedFormField = ({
  children,
  control,
  error,
  className,
  inputClassName,
  formValues,
  question,
  onChange,
  ...componentProps
}: PropsWithChildren<IProps>) => {
  const { asterisk, key, type, required, ...q } = question;
  const Component = FieldTypeMap[type] || TextInput;
  const validator = getValidator(type, question, formValues);

  return (
    <Controller
      key={key}
      control={control}
      name={key}
      rules={{
        required,
        validate: validator,
      }}
      render={({ field }) => {
        return (
          <Component
            {...field}
            {...q}
            {...componentProps}
            error={error?.message || !!error}
            errorText={error?.message}
            className={classnames(styles.field, className)}
            labelClassName={classnames(
              styles.label,
              asterisk && styles.asterisk,
            )}
            inputWrapClassName={styles.inputWrap}
            inputClassName={classnames(styles.input, inputClassName)}
            basic={true}
            onChange={(...args) => {
              if (onChange) onChange(...args);
              field.onChange(...args);
            }}
            warning={getInfoWarningText(question.warning, formValues)}
            formValues={formValues}
          >
            {children}
          </Component>
        );
      }}
    />
  );
};

export default QuashedFormField;
